import { FontSizes, FontWeights, HighContrastSelector } from '@fluentui/react';
export var getStyles = function (props) {
    var _a;
    var theme = props.theme;
    return {
        dividerStyle: {
            marginTop: '24px',
            marginBottom: '24px',
            height: '1px',
            width: '100%',
            alignSelf: 'center',
            background: theme.palette.neutralQuaternaryAlt
        },
        skipToMainLinkStyles: {
            width: '100%',
            height: '48px',
            lineHeight: '48px',
            textAlign: 'center',
            verticalAlign: 'true',
            position: 'absolute',
            top: -100,
            zIndex: 1000,
            textDecorationLine: 'underline',
            color: theme.palette.themeDarkAlt + '!important',
            backgroundColor: theme.palette.neutralLighter + '!important',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            selectors: {
                '&:hover, &:active, &:focus': {
                    color: theme.palette.themeDarkAlt + '!important',
                    backgroundColor: theme.palette.neutralLighter + '!important'
                },
                '&:focus': {
                    top: 0
                },
                ':global([data-testid="uitype-sidepane"])': {
                    marginTop: 48,
                    height: 'calc(100vh - 48px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }
            }
        },
        personaLinkContainer: {
            padding: '12px 0, 0, 0'
        },
        subComponentStyles: {
            appNameLink: {
                root: {
                    height: '46px',
                    lineHeight: '46px',
                    display: 'block',
                    overflow: 'hidden',
                    maxWidth: '100%',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color: theme.palette.white + ' !important',
                    border: '1px solid transparent',
                    fontSize: FontSizes.size16,
                    fontWeight: FontWeights.semibold,
                    selectors: {
                        '&:hover, &:active, &:focus, &:active:hover': {
                            color: theme.palette.white + ' !important',
                            textDecorationLine: 'none'
                        },
                        '&:focus': {
                            borderColor: theme.palette.white + ' !important'
                        }
                    }
                }
            },
            searchBox: {
                root: {
                    backgroundColor: theme.palette.themeLight,
                    border: '1px solid transparent',
                    selectors: {
                        ':hover': {
                            backgroundColor: theme.palette.white,
                            border: '1px solid transparent'
                        },
                        ':focus-within': {
                            backgroundColor: theme.palette.white,
                            border: '1px solid transparent'
                        },
                        ':after': {
                            top: '0px',
                            bottom: '0px',
                            left: '0px',
                            right: '0px',
                            border: '1px solid transparent'
                        }
                    }
                },
                field: {
                    selectors: {
                        '::placeholder': {
                            color: theme.palette.themeDarker
                        }
                    }
                }
            },
            personaLink: {
                root: {
                    fontSize: FontSizes.size14,
                    fontWeight: FontWeights.semibold,
                    color: theme.semanticColors.link,
                    selectors: {
                        ':hover': {
                            color: theme.semanticColors.linkHovered
                        },
                        ':active': {
                            color: theme.semanticColors.linkHovered
                        },
                        ':focus': {
                            color: theme.semanticColors.linkHovered
                        }
                    }
                }
            },
            personaProfile: {
                root: {},
                details: {},
                primaryText: {
                    color: theme.palette.neutralPrimary,
                    fontSize: FontSizes.size14,
                    fontWeight: FontWeights.semibold
                },
                secondaryText: {
                    color: theme.palette.neutralPrimary,
                    fontSize: FontSizes.size12,
                    fontWeight: FontWeights.regular
                },
                tertiaryText: {
                    selectors: (_a = {},
                        _a[HighContrastSelector] = {
                            padding: '1px'
                        },
                        _a)
                },
                optionalText: {},
                textContent: {}
            }
        }
    };
};
//# sourceMappingURL=CoherenceHeader.styles.js.map